import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { RxFormBuilder, RxFormGroup } from '@rxweb/reactive-form-validators';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ActivatedRoute, Router } from '@angular/router';
import { TopbarService } from 'src/app/core/topbar/topbar.service';
import { FormValidatorService } from 'src/app/core/services/form-validator.service';
import { firstValueFrom } from 'rxjs';
import { Vehicle, VehicleLeaseType } from '../_types/vehicle';
import { VehiclesService } from '../_services/vehicles.service';
import { VehiclesTypesService } from '../../vehicles-types/_services/vehicles-types.service';
import { VehicleType } from '../../vehicles-types/_types/vehicle-type';
import { BusinessService } from '../../business/_services/business.service';
import { Business } from '../../business/_types/business';
import { WorkersService } from '../../workers/_services/workers.service';
import {Worker} from '../../workers/_types/worker';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { VehiclesBrandsService } from '../_services/vehicles-brands.service';
import { VehiclesBrandsModelsService } from '../_services/vehicles-brand-models.service';
import { VehicleBrand } from '../_types/vehicleBrand';
import { VehicleBrandModel } from '../_types/vehicleBrandModel';
import { Filter, FilterOperation } from 'src/app/core/jsonapi/filter';
import { IParamsCollection } from 'src/app/core/jsonapi/interfaces/params-collection';
import { FilterBuilder } from 'src/app/core/jsonapi/filters-builder';
import { vehicleOwner } from '../_types/vehicleOwner';
import { VehiclesOwnersService } from '../_services/vehicles-owners.service';
import { Validators } from '@angular/forms';
import { LoginService } from '../../login/login.service';

@Component({
    selector: 'app-vehicles-detail',
    templateUrl: './vehicles-detail.component.html',
    styleUrls: ['./vehicles-detail.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class VehiclesDetailComponent implements OnInit {
  public vehicleFormGroup!: RxFormGroup;

  public vehicle: Vehicle = new Vehicle();
  public vehiclesTypes: Array<VehicleType> = new Array<VehicleType>;
  public vehiclesBrands: VehicleBrand[] = [];
  public vehiclesBrandsModels: VehicleBrandModel[] = [];
  public vehiclesOwners: vehicleOwner[] = [];
  public ownerTypes: any = [
    {
      code: "BUSINESS", name: "Sociedad"
    },
    {
      code: "WORKER", name: "Operario"
    }
  ];

  public leasesType: any[] = [
      {name: 'Renting', id: VehicleLeaseType.Renting},
      {name: 'Propiedad', id: VehicleLeaseType.OnProperty},
      {name: 'Leasing', id: VehicleLeaseType.Leasing},
      {name: 'Otros', id: VehicleLeaseType.Other},
    ];

  public business: Array<Business> = new Array<Business>;
  public workers: Array<Worker> = new Array<Worker>;

  public allowWrite: boolean = false;
  public allowDelete: boolean = false;
  public typeOfDrivers: any[] = [{name: 'Operario', id: 'worker'}, {name: 'Empleado', id: 'employee'}];

  constructor(
    private vehiclesService: VehiclesService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private route: ActivatedRoute,
    private router: Router,
    private topbarService: TopbarService,
    private formBuilder: RxFormBuilder,
    private formValidationService: FormValidatorService,
    private vehiclesTypesService: VehiclesTypesService,
    private vehiclesBrandsService: VehiclesBrandsService,
    private vehiclesBrandsModelsService: VehiclesBrandsModelsService,
    private businessService: BusinessService,
    private workersService: WorkersService,
    private vehiclesOwnersService: VehiclesOwnersService,
    private loginService: LoginService
  ) {

    this.vehicle.hasFunding = true;
    this.vehicle.ownerType = "BUSINESS";
    this.vehicleFormGroup = this.formBuilder.formGroup<Vehicle>(this.vehicle) as RxFormGroup;
    delete this.vehicleFormGroup.controls['vehicleType'];
    delete this.vehicleFormGroup.controls['worker'];
    this.vehicleFormGroup.controls['vehicleOwnerId'].setValidators([Validators.required]); //Por defecto el propietario es obligatorio
    this.vehicleFormGroup.controls['businessId'].setValidators([Validators.required]); //Por defecto el arrendatario es obligatorio
    
  }

  async ngOnInit() {
    this.topbarService.setTitle("Detalles de vehículo");
    this.topbarService.addBreadcrumb("Vehículos", "/vehicles");    
    //let isModal = this.config.data.clientPolicyId;
    let id = this.route.snapshot.params['id'];
    if (id != null && id != '0') {

      await this.loadVehicle(id);
      this.onLeaseTypeChange();  
    }
    this.allowWrite = this.loginService.hasPermission("VEHICLES.WRITE");
    this.allowDelete = this.loginService.hasPermission("VEHICLES.DELETE");

    this.loadVehiclesTypes();
    this.loadBusiness();
    this.loadWorkers();
    this.loadVehiclesBrands();
    this.loadVehiclesOwners();
    this.loadVehiclesBrandsModel();
  }

  async loadVehicle(id: string) {
    this.vehicle = await firstValueFrom(this.vehiclesService.get(id));
    this.vehicleFormGroup.patchValue(this.vehicle);
  }

  async loadVehiclesTypes()
  {
    let response = await firstValueFrom(this.vehiclesTypesService.all());             
    this.vehiclesTypes = response.data;  
  }

  async loadVehiclesBrands()
  {
    let response = await firstValueFrom(this.vehiclesBrandsService.all());             
    this.vehiclesBrands = response.data;  
  }

  async loadVehiclesOwners()
  {
    let response = await firstValueFrom(this.vehiclesOwnersService.all());             
    this.vehiclesOwners = response.data;  
  }

  async loadVehiclesBrandsModel()
  {
    if(this.vehicleFormGroup.value.vehicleBrandId != null && this.vehicleFormGroup.value.vehicleBrandId != ""){
    
      let params: IParamsCollection = {
        filter: FilterBuilder.fromObject({ vehicleBrandId: new Filter(FilterOperation.equals, 'vehicleBrandId', '', this.vehicleFormGroup.value.vehicleBrandId) }).build()
      }
  
      let response = await firstValueFrom(this.vehiclesBrandsModelsService.all(params));
      this.vehiclesBrandsModels = response.data;  
    }
  }

  async loadBusiness() {

    let response = await firstValueFrom(this.businessService.all());             
    this.business = response.data; 
  }

  async loadWorkers(){
    let response = await firstValueFrom(this.workersService.all());             
    this.workers = response.data; 
  }
  
  onOwnerTypeChange(e: any) {    
    this.vehicle.ownerType = e.value;
    //ponemos los obligatorios o no dependiendo del tipo de propietario
    if (this.vehicle.ownerType == "BUSINESS") { 
      this.vehicleFormGroup.controls['businessId'].setValidators([Validators.required]);
    }
  }
  
  onLeaseTypeChange(){
    if(this.vehicleFormGroup.value.leaseType != VehicleLeaseType.OnProperty){
      this.vehicleFormGroup.controls['vehicleOwnerId'].setValidators([Validators.required]);
    }else{

      this.vehicleFormGroup.controls['vehicleOwnerId'].setValidators(null); //Por defecto el propietario es obligatorio
    }
  }

  async save() {
    
    let valid = this.formValidationService.validateForm(this.vehicleFormGroup);    
    if (valid) {
      this.vehicle = Object.assign(this.vehicle, this.vehicleFormGroup.value);
      
      let vehicle = await firstValueFrom(this.vehiclesService.save(this.vehicle));

      this.messageService.add({ closable: true, severity: 'success', summary: "Vehículo guardado correctamente." });

      
      this.router.navigate(['vehicles']);
            

    } else {
      this.messageService.add({ closable: true, severity: 'error', summary: "Error", detail: "Existen errores, por favor revise el formulario de datos." });
    }
  }

  async delete() {
    this.confirmationService.confirm({
      message: "¿Está seguro que desea eliminar el vehículo "+this.vehicle.name+"?",
      header: "Eliminar vehículo",
      acceptLabel: "Aceptar",
      rejectLabel: "Cancelar",
      acceptButtonStyleClass: "p-button-danger",
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.vehiclesService.delete(this.vehicle.id).subscribe({
          next: (data: any) => {
            this.cancel();
            this.messageService.add({ closable: true, severity: 'success', detail: "Vehículo eliminado correctamente." });
          },
          error: (error: any) => {
            this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
          }
        });
      },
      reject: (error: any) => {
        this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
      }
    });
  }

  cancel() {
    this.router.navigate(['vehicles']);
  }

}
